import { render, staticRenderFns } from "./PriceAlerts.vue?vue&type=template&id=1c5851ae&"
import script from "./PriceAlerts.vue?vue&type=script&lang=js&"
export * from "./PriceAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports